import { render, staticRenderFns } from "./BreadBag.vue?vue&type=template&id=4020b937&"
import script from "./BreadBag.vue?vue&type=script&lang=js&"
export * from "./BreadBag.vue?vue&type=script&lang=js&"
import style0 from "./BreadBag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports